export function windowPushHistory(url) {
    window.history.pushState(null, null, url);
}
export function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}
